import { Select } from '@chakra-ui/react';

const options = [
  {
    key: 'ACTIVE',
    label: 'Active',
  },
  {
    key: 'INACTIVE',
    label: 'Inactive',
  },
  {
    key: 'FUTURE_ACTIVE',
    label: 'Future Active',
  },
];

const BookStatusFilter = ({ selectedStatus, setSelectedStatus }) => {
  return (
    <Select
      size="sm"
      placeholder="Any Status"
      value={selectedStatus}
      onChange={(e) => setSelectedStatus(e.target.value)}
    >
      {options.map((status) => (
        <option key={status.key} value={status.key}>
          {status.label}
        </option>
      ))}
    </Select>
  );
};

export default BookStatusFilter;
